import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import './closeButton.styles.scss';

import imgClose from 'images/cross-thin-24.svg';

export default class CloseButton extends Component {
    constructor(props) {
        super(props);
        let onClick;
        let className;
        let text;

        if (this.props.container === 'toast') {
            onClick = this.props.closeToast;
            className = 'Toastify__close-button';
            text = 'toastr_close_button';
        } else {
            onClick = this.props.onClick;
            className = 'ikea-modal__close';
            text = 'modal_close';
        }

        this.state = { onClick, className, text };
    }
    render() {
        return (
            <Button
                className={this.state.className}
                icon={imgClose}
                iconOnly
                text={this.state.text}
                theme="unstyled"
                onClick={this.state.onClick}
            />
        );
    }
}

CloseButton.propTypes = {
    // 'toast' or 'modal'
    container: PropTypes.string.isRequired,
    closeToast: PropTypes.func,
    onClick: PropTypes.func,
};
